import React, { useState } from 'react';
import {
  Box,
  Button,
  TextField,
  Typography,
  Paper,
  Grid,
  MenuItem,
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import SuperAdminLayout from '../../../layouts/SuperAdminLayout';
import api from '../../../utils/api';

const CreateCustomer = () => {
  const [formData, setFormData] = useState({
    partyName: '',
    partyMarka: '',
    address: '',
    transporterName: '',
    transporterAddress: '',
    paymentType: '',
    creditBalance: 0,
    creditTime: 0,
    openingBalance: 0,
    openingBalanceType: '',
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || !user.id) {
      alert('Super admin not found');
      return;
    }

    console.log(formData);

    const customerData = {
      ...formData,
      superAdminId: user.id,
    };

    try {
      await api.post(`/api/customers/create`, customerData);
      navigate('/super-admin/customers');
    } catch (err) {
      console.error('Failed to create customer:', err);
      alert('Error creating customer');
    }
  };

  return (
    <SuperAdminLayout>
      <Paper sx={{ p: 4, maxWidth: 'screen', mx: 'auto' }}>
        <Typography variant="h5" gutterBottom>
          Create Customer
        </Typography>
        <Box component="form" onSubmit={handleSubmit} noValidate>
          <Grid container spacing={2}>
            <Grid item xs={12} sm={6}>
              <TextField
                required
                fullWidth
                label="Party Name"
                name="partyName"
                value={formData.partyName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Party Marka"
                name="partyMarka"
                value={formData.partyMarka}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                required
                fullWidth
                label="Address"
                name="address"
                value={formData.address}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Transporter Name"
                name="transporterName"
                value={formData.transporterName}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                label="Transporter Address"
                name="transporterAddress"
                value={formData.transporterAddress}
                onChange={handleChange}
              />
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField
                select
                sx={{ width: 207 }}
                label="O/P Balance Type"
                value={formData.openingBalanceType}
                onChange={(e) =>
                  setFormData({
                    ...formData,
                    openingBalanceType: e.target.value,
                  })
                }
                fullWidth
              >
                <MenuItem value="debit">Debit</MenuItem>
                <MenuItem value="credit">Credit</MenuItem>
              </TextField>
            </Grid>

            <TextField
              label="Opening Balance"
              type="number"
              sx={{ width: 207 }}
              value={formData.openingBalance}
              onChange={(e) =>
                setFormData({
                  ...formData,
                  openingBalance: Number(e.target.value),
                })
              }
              fullWidth
            />
            <Grid item xs={12} sm={6}>
              <TextField
                fullWidth
                select
                sx={{ width: 207 }}
                label="Payment Type"
                value={formData.paymentType}
                onChange={(e) =>
                  setFormData({ ...formData, paymentType: e.target.value })
                }
              >
                <MenuItem value="Cash">Cash</MenuItem>
                <MenuItem value="Credit">Credit</MenuItem>
              </TextField>
            </Grid>

            {formData.paymentType === 'Credit' && (
              <>
                <TextField
                  label="Credit Balance"
                  type="number"
                  sx={{ width: 207 }}
                  value={formData.creditBalance}
                  onChange={(e) =>
                    setFormData({ ...formData, creditBalance: e.target.value })
                  }
                  fullWidth
                />
                <TextField
                  label="Credit Time (in days)"
                  type="number"
                  sx={{ width: 207 }}
                  value={formData.creditTime}
                  onChange={(e) =>
                    setFormData({ ...formData, creditTime: e.target.value })
                  }
                  fullWidth
                />
              </>
            )}
            <Grid item xs={12} display="flex" justifyContent="flex-end">
              <Button variant="contained" color="primary" type="submit">
                Save Customer
              </Button>
            </Grid>
          </Grid>
        </Box>
      </Paper>
    </SuperAdminLayout>
  );
};

export default CreateCustomer;
